import React from 'react';
import { Row, Col } from 'antd';
import { I18n } from '@aws-amplify/core';
import { GhostButton, PrimaryButton } from '@/components/ui/Button';

interface StepFooterButtonsProps {
	onSubmit?: React.MouseEventHandler<HTMLElement> | undefined;
	onCancel?: React.MouseEventHandler<HTMLElement> | undefined;
	nextButtonText?: string;
	previousButtonText?: string;
	isLoadingNextButton?: boolean;
	isLoadingPreviousButton?: boolean;
	isDisabledNextButton?: boolean;
	isDisabledPreviousButton?: boolean;
	isHiddenPreviousButton?: boolean;
	isHiddenNextButton?: boolean;
}

export function StepFooterButtons({
	onSubmit,
	onCancel,
	isLoadingPreviousButton = false,
	isLoadingNextButton = false,
	isDisabledNextButton = false,
	isDisabledPreviousButton = false,
	nextButtonText = 'Next',
	previousButtonText = 'Previous',
	isHiddenPreviousButton = false,
	isHiddenNextButton = false
}: Readonly<StepFooterButtonsProps>) {
	return (
		<Row justify="center" gutter={16}>
			{!isHiddenPreviousButton && (
				<Col>
					<GhostButton
						type="ghost"
						onClick={onCancel}
						loading={isLoadingPreviousButton}
						disabled={isDisabledPreviousButton}
					>
						{I18n.get(previousButtonText)}
					</GhostButton>
				</Col>
			)}
			{!isHiddenNextButton && (
				<Col>
					<PrimaryButton
						type="primary"
						onClick={onSubmit}
						loading={isLoadingNextButton}
						disabled={isDisabledNextButton}
					>
						{I18n.get(nextButtonText)}
					</PrimaryButton>
				</Col>
			)}
		</Row>
	);
}
